import React from 'react';
import {FormBlock, FormPost, FormBlockFieldOther} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldOther;
}

interface Props {
  block: Block;
  post: FormPost;
}

export default ({block, post}: Props) => {
  const blockable = block.formBlockable;
  const label = blockable.title;
  const value = post.formPostOtherNumbers.find(
    (item) => item.formBlockFieldOtherId === block.formBlockable.id,
  )?.value;

  return (
    <div className="w-full flex gap-4 items-center mb-3">
      <h4 className="text-c-light text-sm m-0 w-24">{label}</h4>
      <p className="m-0 text-base flex-1">{value}</p>
    </div>
  );
};
